import { Field, Form, Formik } from 'formik'
import React from 'react'

import { LeavingGuard } from '@components/utils/LeavingGuard'
import { Fieldset, HeadContent, Input, Subsection } from '@fourthwall/components'
import { ConfirmBar } from '@modules/Dashboard/modules/ConfirmBar'
import { ResendVerificationEmailButton } from '@modules/Dashboard/pages/Account/pages/General/components/ResendVerificationEmailButton'

import type { Values } from './General.types'
import { DetailsList } from './components/DetailsList/DetailsList'
import { validationSchema } from './consts'

export const GENERAL_VIEW_TITLE = 'General'

export type GeneralViewProps = {
  initialValues: Values
  loginDetails: {
    email: string
    verified: boolean
  }
  onSubmit: (values: Values) => void
}

export const GeneralView = ({ initialValues, loginDetails, onSubmit }: GeneralViewProps) => (
  <>
    <HeadContent title={`${GENERAL_VIEW_TITLE} \u2013 Account settings`} />
    <Formik<Values>
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({ dirty, isValid, isSubmitting, handleSubmit, resetForm, submitForm }) => (
        <Form>
          <Subsection title="Profile">
            <Fieldset>
              <Fieldset.Row>
                <Fieldset.Item>
                  <Field component={Input} name="fullName" label="Full name" />
                </Fieldset.Item>
              </Fieldset.Row>
            </Fieldset>
          </Subsection>
          <Subsection title="Login details" noMargin>
            <Fieldset>
              <Fieldset.Row>
                <Fieldset.Item>
                  <DetailsList>
                    <DetailsList.Item
                      title="Email"
                      subtitle={loginDetails.email}
                      tagProps={{
                        label: loginDetails.verified ? 'Verified' : 'Unverified',
                        appearance: loginDetails.verified ? 'success' : 'alert',
                      }}
                      actionButton={<ResendVerificationEmailButton />}
                    />
                  </DetailsList>
                </Fieldset.Item>
              </Fieldset.Row>
            </Fieldset>
          </Subsection>

          <ConfirmBar
            isOpen={dirty}
            isLoading={isSubmitting}
            onConfirm={handleSubmit}
            onCancel={resetForm}
          />
          <LeavingGuard when={dirty} isValid={isValid} onSave={submitForm} />
        </Form>
      )}
    </Formik>
  </>
)
